import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useRechargeStore} from '../recharge.store';
import {
  getMultiple,
  RechargeTabApiRule,
  getVipWeekCardConfigList,
} from '../recharge-tab/recharge-tab.service';
import {RechargeTable, WeekCardTable, TableRule} from './components';

interface RechargeRuleProps {
  fromWeekCard?: boolean;
}

const RechargeRule: React.FC<RechargeRuleProps> = ({fromWeekCard = false}) => {
  const {t} = useTranslation();
  const {activeTabId, tabs} = useRechargeStore();
  const [waterMultiplier, setWaterMultiplier] = useState<number>(5);
  const [weekCardConfigs, setWeekCardConfigs] = useState<any[]>([]);

  const activeTab = tabs.find(tab => tab.id === activeTabId);

  // 获取流水倍数
  useEffect(() => {
    const fetchMultiplier = async () => {
      try {
        const multiplier = await getMultiple();
        setWaterMultiplier(multiplier);
      } catch (error) {
        console.error('获取流水倍数失败:', error);
      }
    };
    fetchMultiplier();
  }, []);

  // 获取周卡配置
  useEffect(() => {
    const fetchWeekCardConfigs = async () => {
      try {
        const configs = await getVipWeekCardConfigList();
        console.log('configs', configs);
        setWeekCardConfigs(configs);
      } catch (error) {
        console.error('获取周卡配置失败:', error);
      }
    };
    fetchWeekCardConfigs();
  }, []);

  // 判断是否为周卡
  const isWeekCard = fromWeekCard || activeTabId === -2;

  // 获取规则数据
  const getRulesData = (): RechargeTabApiRule[] => {
    if (isWeekCard) {
      return weekCardConfigs.map(config => ({
        name: config.cardName.toString() || '',
        minAmount: config.price || 0,
        maxAmount: config.price || 0,
        valueType: 'PERCENT_VALUE',
        value: config.bonus?.toString() || '0',
      }));
    }
    return activeTab?.activityRechargeAwardList || [];
  };

  const rulesData = getRulesData();

  return (
    <div>
      <div className="rounded-t-xl border-b border-dashed border-[#9FA5AC] bg-[#E6ECFF] p-3 flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <div className="text-t2 font-bold text-sm">
            <div>BETTING</div>
            <div>REQUIREMENTS:</div>
          </div>
          <span className="text-t2 font-bold text-sm">
            Water multiplier {waterMultiplier}
          </span>
        </div>
      </div>

      {/* 内容区域 */}
      <div className="flex flex-col items-start gap-3 p-3 self-stretch rounded-b-xl border-r border-b border-l border-[#E6ECFF] bg-white">
        {/* 标题区域 不是周卡并且有规则 */}
        {!isWeekCard && rulesData.length > 0 && (
          <div>
            <div className="flex items-center mb-1">
              <div className="w-1 h-3 bg-[#166BE5] mr-2" />
              <div className="text-t1 font-bold text-sm">
                {t('recharge.rechargePromotions', 'Recharge Promotions')}
              </div>
            </div>
            <div className="text-[#48505D] text-[8px]">
              {t(
                'recharge.selectAndRecharge',
                'Select And Recharge To Automatically Participate',
              )}
            </div>
          </div>
        )}

        {/* 周卡标题 */}
        {isWeekCard && (
          <div>
            <div className="flex items-center">
              <div className="w-1 h-3 bg-[#166BE5] mr-2" />
              <div className="text-t1 font-bold text-sm">
                {t('recharge.eventRules', 'Event Rules')}
              </div>
            </div>
          </div>
        )}

        {/* 规则表格 */}
        {isWeekCard
          ? weekCardConfigs.length > 0 && (
              <WeekCardTable weekCardConfigs={weekCardConfigs} />
            )
          : !fromWeekCard &&
            rulesData.length > 0 && (
              <RechargeTable rules={rulesData as TableRule[]} />
            )}

        <div className="flex flex-col gap-2 text-xs font-medium text-[#48505D]">
          {/* 流水要求说明 */}
          <div className="text-[#48505D] text-xs flex items-center gap-2">
            {t(
              'recharge.wageringRequirement',
              `After Participating In This Event, Your Withdrawal Will Be Subject To A Wagering Requirement Of ${waterMultiplier} Times The Deposit Amount.`,
            )}
          </div>

          {/* 充值提示 */}
          <>
            <h3 className="font-bold text-t1 text-sm ">
              • {t('recharge.depositTips', 'Deposit Tips')}:
            </h3>
            <ol className="list-decimal list-inside  space-y-1">
              <li>
                {t(
                  'recharge.depositTip1',
                  'Each Deposit Will Be Credited Within 1-5 Minutes.',
                )}
              </li>
              <li>
                {t(
                  'recharge.depositTip2',
                  'After The Payment Is Successful, Please Return To The Game Deposit Page To Check Your Account Balance.',
                )}
              </li>
              <li>
                {t(
                  'recharge.depositTip3',
                  'If Your Deposit Does Not Arrive Within 30 Minutes, Please Contact Customer Service For Help.',
                )}
              </li>
            </ol>
          </>

          {/* 重要提示 */}
          <>
            <h3 className="font-bold text-t1 text-sm ">
              • {t('recharge.importantNotes', 'Important Notes')}:
            </h3>
            <div className="">
              {t(
                'recharge.importantNote1',
                'Please Do Not Modify The Payment Amount. Avoid Reusing Saved QR Codes Or UPI Accounts For Multiple Payments.',
              )}
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default RechargeRule;
